const Izmir = () => {
    return ( 
        <div id="Izmir" className="section">
            <div className="jumbotron">
                <p className="lead">
                    Izmir Off Season (17-18-19 December 2021) was the first competition we took part in.
                    This competition, in which we reached the semi-finals, didn't only let us get a lot
                    of experience, but also helped us measure ourselves as a team.
                </p>
            </div>
        </div>
    );
}

export default Izmir;